const siteMetadata = {
  title: "P.P. Savani Hospital - Leading Healthcare Facility",
  author: "P.P. Savani Hospital Team",
  description:
    "P.P. Savani Hospital is dedicated to providing advanced medical care and services in the region. Experience compassionate patient care with state-of-the-art infrastructure.",
  language: "en-us",
  siteUrl: "https://www.PPSavaniHospital.in",
  email: "infoppsavanihospital@gmail.com",
  phoneNumber: "+91 99250 77200",
  whatsappNumber: "https://wa.me/+917435899929",
  fb: "https://www.facebook.com/ppshisurat",
  instagram: "https://www.instagram.com/ppsavanihospital/",
  twitter: "https://x.com/?mx=2",
  youtube: "https://www.youtube.com/@PPSavaniHospital/shorts",
  service: "24*7 Emergency Service",
  locale: "en-US",
  siteName: "P.P. Savani Hospital",
  location:
    "Mansi Building, C/O. P P Savani Hospital, Varachha Main Rd, opposite Kapodra Police Station, Surat.",
  openTime: "MON - SUN : 7:00 AM to 10:00 PM",
  siteLogo: "/assets/logo/logo.png",
};

module.exports = siteMetadata;
